export default function addTag(value) {
  return {
    type: "ADD_TAG",
    value,
  };
}
